import ActionButton from "@/components/Button/ActionButton";
import Icon from "@/components/Icon/Icon";
import { HStack, VStack } from "@/components/Layout";
import { ViewportLoader } from "@/components/Loading/ViewportLoader";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { createFileRoute } from "@tanstack/react-router";
import { OperationPackageIndividualContainer } from "./-components/operation-package";
import { useGetSelfServiceTask } from "./-query";

export const Route = createFileRoute("/_individual/individual/task/$id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "individualPages.tasks",
  });
  const { id } = Route.useParams();
  const navigate = Route.useNavigate();
  const { data, isLoading, error } = useGetSelfServiceTask(id);

  if (isLoading) {
    return <ViewportLoader />;
  }
  if (error) {
    return <div>{error.message}</div>;
  }
  if (!data) {
    return <></>;
  }

  return (
    <VStack className="p-8 gap-2">
      <HStack className="justify-between">
        <HStack className="items-center">
          <Icon iconName="ChevronLeft" />
          <ActionButton
            variant="ghost"
            onClick={() => {
              navigate({ to: "/individual" });
            }}
          >
            {t("navigateToHome")}
          </ActionButton>
        </HStack>
      </HStack>
      <OperationPackageIndividualContainer id={id} data={data} />
    </VStack>
  );
}
